import React from "react";
import CreateAccount from "../components/widgets/createaccount";

export function CreateAccountPage() {
  return (
    <div>
      <CreateAccount />
    </div>
  );
}
export default CreateAccountPage;
